export default __webpack_public_path__ + "locales/zh-CN/Files.json?hash=49f433251a3e3b135a8b1878ed03714d";